function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "SSL-secure",
  transform: "translate(0)"
}, React.createElement("path", {
  id: "Path_918",
  "data-name": "Path 918",
  d: "M36.977,130.712H4.3a4.317,4.317,0,0,1-4.3-4.3v-28a4.317,4.317,0,0,1,4.3-4.3H36.977a4.317,4.317,0,0,1,4.3,4.3v28.024A4.3,4.3,0,0,1,36.977,130.712Z",
  transform: "translate(0 -73.846)",
  fill: "#f7cf80"
}), React.createElement("path", {
  id: "Path_919",
  "data-name": "Path 919",
  d: "M112.236,94.1H95.9v36.633h16.336a4.317,4.317,0,0,0,4.3-4.3V98.4A4.3,4.3,0,0,0,112.236,94.1Z",
  transform: "translate(-75.259 -73.846)",
  fill: "#e6ae44"
}), React.createElement("path", {
  id: "Path_920",
  "data-name": "Path 920",
  d: "M45.675,0A13.774,13.774,0,0,0,31.9,13.775v6.457h4.089V13.861a9.686,9.686,0,1,1,19.371,0v6.392H59.45V13.775A13.774,13.774,0,0,0,45.675,0Z",
  transform: "translate(-25.034)",
  fill: "#ababab"
}), React.createElement("g", {
  id: "Group_825",
  "data-name": "Group 825",
  transform: "translate(49.181 20.447)"
}, React.createElement("path", {
  id: "Path_921",
  "data-name": "Path 921",
  d: "M228.5,109.478l2.583-.215a5.718,5.718,0,0,0,.861,2.54,4.654,4.654,0,0,0,2.088,1.614,7.9,7.9,0,0,0,3.164.624,7.321,7.321,0,0,0,2.755-.474,3.789,3.789,0,0,0,1.786-1.27,2.988,2.988,0,0,0,.581-1.765,2.78,2.78,0,0,0-.56-1.7,4.284,4.284,0,0,0-1.873-1.227,36.039,36.039,0,0,0-3.681-1.012,18.118,18.118,0,0,1-3.982-1.291,5.768,5.768,0,0,1-2.217-1.916,4.638,4.638,0,0,1-.732-2.583,5.359,5.359,0,0,1,.882-2.927,5.6,5.6,0,0,1,2.6-2.066,9.815,9.815,0,0,1,3.788-.71,10.285,10.285,0,0,1,4.046.732,5.906,5.906,0,0,1,2.69,2.174,6.293,6.293,0,0,1,1.012,3.25l-2.626.194a4.268,4.268,0,0,0-1.442-2.97,5.588,5.588,0,0,0-3.594-1.012,5.793,5.793,0,0,0-3.616.9,2.735,2.735,0,0,0-1.141,2.2,2.306,2.306,0,0,0,.8,1.83c.517.474,1.894.969,4.133,1.464a28.409,28.409,0,0,1,4.585,1.313,6.278,6.278,0,0,1,2.669,2.109,5.107,5.107,0,0,1,.861,2.949,5.757,5.757,0,0,1-.947,3.121,6.338,6.338,0,0,1-2.712,2.282,9.542,9.542,0,0,1-3.982.818,12.094,12.094,0,0,1-4.714-.818,6.426,6.426,0,0,1-2.97-2.454A7.244,7.244,0,0,1,228.5,109.478Z",
  transform: "translate(-228.5 -95.078)"
}), React.createElement("path", {
  id: "Path_922",
  "data-name": "Path 922",
  d: "M322.6,117.363V96.7h14.959v2.432H325.333v6.328h11.429v2.432H325.333v7.038h12.7v2.432Z",
  transform: "translate(-302.346 -96.334)"
}), React.createElement("path", {
  id: "Path_923",
  "data-name": "Path 923",
  d: "M423.662,108.8l2.733.689a9.339,9.339,0,0,1-3.1,5.144,8.5,8.5,0,0,1-5.467,1.765,9.863,9.863,0,0,1-5.445-1.356A8.465,8.465,0,0,1,409.2,111.1a14.048,14.048,0,0,1-1.1-5.553,12.3,12.3,0,0,1,1.227-5.639,8.6,8.6,0,0,1,3.508-3.659A10.14,10.14,0,0,1,417.85,95a8.414,8.414,0,0,1,5.209,1.571,8.212,8.212,0,0,1,2.949,4.434l-2.647.667a6.426,6.426,0,0,0-2.088-3.293,5.549,5.549,0,0,0-3.444-1.033,6.7,6.7,0,0,0-3.982,1.141,6.069,6.069,0,0,0-2.26,3.078,13.286,13.286,0,0,0,.129,8.566,5.86,5.86,0,0,0,2.389,2.949,6.733,6.733,0,0,0,3.508.969,5.941,5.941,0,0,0,3.9-1.334A6.768,6.768,0,0,0,423.662,108.8Z",
  transform: "translate(-369.444 -95)"
}), React.createElement("path", {
  id: "Path_924",
  "data-name": "Path 924",
  d: "M522.438,96.7h2.733v11.946a14.025,14.025,0,0,1-.71,4.95,6.081,6.081,0,0,1-2.54,2.992,8.936,8.936,0,0,1-4.821,1.141,9.929,9.929,0,0,1-4.757-1.012,5.8,5.8,0,0,1-2.647-2.906,14.025,14.025,0,0,1-.8-5.187V96.7h2.733v11.924a11.869,11.869,0,0,0,.5,3.96,3.741,3.741,0,0,0,1.722,1.959,6.087,6.087,0,0,0,2.992.689c2,0,3.444-.452,4.3-1.378.861-.9,1.291-2.669,1.291-5.252Z",
  transform: "translate(-448.548 -96.334)"
}), React.createElement("path", {
  id: "Path_925",
  "data-name": "Path 925",
  d: "M605.9,117.363V96.7h9.169a12.209,12.209,0,0,1,4.2.56,4.624,4.624,0,0,1,2.3,1.959,5.826,5.826,0,0,1,.861,3.121,5.169,5.169,0,0,1-1.421,3.7,7.191,7.191,0,0,1-4.391,1.916,6.925,6.925,0,0,1,1.657,1.033,15.08,15.08,0,0,1,2.281,2.755l3.594,5.618h-3.444l-2.734-4.3a34.083,34.083,0,0,0-1.98-2.841,5.878,5.878,0,0,0-1.4-1.378,4.289,4.289,0,0,0-1.248-.56,8.09,8.09,0,0,0-1.528-.108h-3.164v9.191Zm2.733-11.537h5.876a8.731,8.731,0,0,0,2.927-.387,3.064,3.064,0,0,0,1.614-1.248,3.34,3.34,0,0,0,.56-1.851,3.074,3.074,0,0,0-1.055-2.411,5,5,0,0,0-3.358-.947h-6.543v6.844Z",
  transform: "translate(-524.67 -96.334)"
}), React.createElement("path", {
  id: "Path_926",
  "data-name": "Path 926",
  d: "M702.9,117.363V96.7h14.959v2.432H705.634v6.328h11.429v2.432H705.634v7.038h12.7v2.432Z",
  transform: "translate(-600.792 -96.334)"
})), React.createElement("g", {
  id: "Group_826",
  "data-name": "Group 826",
  transform: "translate(49.999 46.921)"
}, React.createElement("path", {
  id: "Path_927",
  "data-name": "Path 927",
  d: "M232.3,224.8l1.227-.108a2.752,2.752,0,0,0,.409,1.205,2.134,2.134,0,0,0,.99.753,3.761,3.761,0,0,0,1.507.28,3.576,3.576,0,0,0,1.313-.215,1.7,1.7,0,0,0,.839-.6,1.508,1.508,0,0,0,.28-.839,1.262,1.262,0,0,0-.258-.8,1.859,1.859,0,0,0-.882-.581,15.435,15.435,0,0,0-1.743-.474,8.906,8.906,0,0,1-1.894-.6,2.591,2.591,0,0,1-1.055-.9,2.2,2.2,0,0,1-.344-1.227,2.478,2.478,0,0,1,.43-1.378,2.535,2.535,0,0,1,1.227-.969,5.141,5.141,0,0,1,3.7,0,2.661,2.661,0,0,1,1.27,1.033,2.923,2.923,0,0,1,.474,1.55l-1.248.086a2.06,2.06,0,0,0-.667-1.4,2.546,2.546,0,0,0-1.7-.474,2.851,2.851,0,0,0-1.722.43,1.248,1.248,0,0,0-.538,1.033,1.084,1.084,0,0,0,.387.861,5.1,5.1,0,0,0,1.959.689,14.049,14.049,0,0,1,2.174.624,3.194,3.194,0,0,1,1.27.99,2.379,2.379,0,0,1,.409,1.4,2.605,2.605,0,0,1-.452,1.464,3.054,3.054,0,0,1-1.291,1.076,4.446,4.446,0,0,1-1.894.387,5.531,5.531,0,0,1-2.217-.387,2.991,2.991,0,0,1-1.4-1.162A3.417,3.417,0,0,1,232.3,224.8Z",
  transform: "translate(-232.3 -218)",
  fill: "#ababab"
}), React.createElement("path", {
  id: "Path_928",
  "data-name": "Path 928",
  d: "M274.7,224.8l1.227-.108a2.752,2.752,0,0,0,.409,1.205,2.134,2.134,0,0,0,.99.753,3.761,3.761,0,0,0,1.507.28,3.576,3.576,0,0,0,1.313-.215,1.7,1.7,0,0,0,.839-.6,1.508,1.508,0,0,0,.28-.839,1.262,1.262,0,0,0-.258-.8,1.859,1.859,0,0,0-.882-.581,15.436,15.436,0,0,0-1.743-.474,8.906,8.906,0,0,1-1.894-.6,2.591,2.591,0,0,1-1.055-.9,2.2,2.2,0,0,1-.344-1.227,2.478,2.478,0,0,1,.43-1.378,2.535,2.535,0,0,1,1.227-.969,5.141,5.141,0,0,1,3.7,0,2.661,2.661,0,0,1,1.27,1.033,2.923,2.923,0,0,1,.474,1.55l-1.248.086a2.06,2.06,0,0,0-.667-1.4,2.546,2.546,0,0,0-1.7-.474,2.851,2.851,0,0,0-1.722.43,1.248,1.248,0,0,0-.538,1.033,1.084,1.084,0,0,0,.387.861,5.1,5.1,0,0,0,1.959.689,14.048,14.048,0,0,1,2.174.624,3.194,3.194,0,0,1,1.27.99,2.38,2.38,0,0,1,.409,1.4,2.605,2.605,0,0,1-.452,1.464,3.054,3.054,0,0,1-1.291,1.076,4.446,4.446,0,0,1-1.894.387,5.531,5.531,0,0,1-2.217-.387,2.991,2.991,0,0,1-1.4-1.162A3.417,3.417,0,0,1,274.7,224.8Z",
  transform: "translate(-265.574 -218)",
  fill: "#ababab"
}), React.createElement("path", {
  id: "Path_929",
  "data-name": "Path 929",
  d: "M318.9,228.493V218.7h1.291v8.631h4.821v1.162Z",
  transform: "translate(-300.261 -218.549)",
  fill: "#ababab"
}), React.createElement("path", {
  id: "Path_930",
  "data-name": "Path 930",
  d: "M369.9,228.493V218.7h7.081v1.162h-5.79v2.992h5.424v1.141h-5.424v3.336H377.2v1.162Z",
  transform: "translate(-340.284 -218.549)",
  fill: "#ababab"
}), React.createElement("path", {
  id: "Path_931",
  "data-name": "Path 931",
  d: "M412.1,228.493V218.7h1.334l5.144,7.684V218.7h1.248v9.793h-1.334l-5.144-7.684v7.684Z",
  transform: "translate(-373.401 -218.549)",
  fill: "#ababab"
}), React.createElement("path", {
  id: "Path_932",
  "data-name": "Path 932",
  d: "M463.661,224.522l1.291.323a4.409,4.409,0,0,1-1.464,2.432,4.045,4.045,0,0,1-2.583.839,4.688,4.688,0,0,1-2.583-.646,3.984,3.984,0,0,1-1.507-1.873,6.646,6.646,0,0,1-.517-2.626,5.806,5.806,0,0,1,.581-2.669,4,4,0,0,1,1.657-1.722,4.883,4.883,0,0,1,2.368-.581,4.074,4.074,0,0,1,2.475.753,3.87,3.87,0,0,1,1.4,2.109l-1.27.3a3.078,3.078,0,0,0-.99-1.55,2.641,2.641,0,0,0-1.636-.5,3.173,3.173,0,0,0-1.894.538,2.85,2.85,0,0,0-1.055,1.442,6.313,6.313,0,0,0,.065,4.046,2.742,2.742,0,0,0,1.141,1.4A3.254,3.254,0,0,0,460.8,227a2.871,2.871,0,0,0,1.851-.624A3.289,3.289,0,0,0,463.661,224.522Z",
  transform: "translate(-408.087 -218)",
  fill: "#ababab"
}), React.createElement("path", {
  id: "Path_933",
  "data-name": "Path 933",
  d: "M504,228.493V218.7h4.348a5.78,5.78,0,0,1,1.98.258,2.285,2.285,0,0,1,1.1.926,2.758,2.758,0,0,1,.409,1.485,2.507,2.507,0,0,1-.667,1.765,3.426,3.426,0,0,1-2.088.9,3.015,3.015,0,0,1,.775.5,6.587,6.587,0,0,1,1.076,1.291l1.7,2.669H511l-1.291-2.045c-.387-.581-.689-1.033-.926-1.356a2.6,2.6,0,0,0-.667-.646,1.725,1.725,0,0,0-.581-.258,5.246,5.246,0,0,0-.732-.043h-1.507v4.348Zm1.291-5.467h2.777a4.037,4.037,0,0,0,1.4-.194,1.491,1.491,0,0,0,.753-.581,1.571,1.571,0,0,0,.258-.882,1.481,1.481,0,0,0-.5-1.141,2.309,2.309,0,0,0-1.593-.452h-3.1Z",
  transform: "translate(-445.52 -218.549)",
  fill: "#ababab"
}), React.createElement("path", {
  id: "Path_934",
  "data-name": "Path 934",
  d: "M547.667,228.572v-4.133L543.9,218.8h1.571l1.937,2.949c.366.56.689,1.1.99,1.657.3-.517.646-1.1,1.076-1.722l1.894-2.884h1.507l-3.9,5.639v4.154h-1.313Z",
  transform: "translate(-476.833 -218.628)",
  fill: "#ababab"
}), React.createElement("path", {
  id: "Path_935",
  "data-name": "Path 935",
  d: "M591,228.493V218.7h3.7a8.821,8.821,0,0,1,1.485.086,3.2,3.2,0,0,1,1.205.452,2.28,2.28,0,0,1,.775.947,3.108,3.108,0,0,1,.3,1.334,2.96,2.96,0,0,1-.8,2.109,3.793,3.793,0,0,1-2.863.861h-2.518v3.982H591Zm1.291-5.123h2.54a2.651,2.651,0,0,0,1.786-.474,1.684,1.684,0,0,0,.538-1.313,1.9,1.9,0,0,0-.3-1.055,1.414,1.414,0,0,0-.818-.581,5.129,5.129,0,0,0-1.205-.086h-2.54Z",
  transform: "translate(-513.795 -218.549)",
  fill: "#ababab"
}), React.createElement("path", {
  id: "Path_936",
  "data-name": "Path 936",
  d: "M633.229,228.493v-8.631H630V218.7h7.748v1.162H634.52v8.631Z",
  transform: "translate(-544.401 -218.549)",
  fill: "#ababab"
}), React.createElement("path", {
  id: "Path_937",
  "data-name": "Path 937",
  d: "M673.2,228.493V218.7h1.291v9.793Z",
  transform: "translate(-578.303 -218.549)",
  fill: "#ababab"
}), React.createElement("path", {
  id: "Path_938",
  "data-name": "Path 938",
  d: "M688,223.187a5.254,5.254,0,0,1,1.313-3.81A4.446,4.446,0,0,1,692.692,218a4.749,4.749,0,0,1,2.454.646,4.212,4.212,0,0,1,1.657,1.808,5.813,5.813,0,0,1,.581,2.626,5.73,5.73,0,0,1-.6,2.669,4.261,4.261,0,0,1-1.7,1.786,4.784,4.784,0,0,1-2.368.6,4.589,4.589,0,0,1-2.475-.667,4.392,4.392,0,0,1-1.657-1.829A5.415,5.415,0,0,1,688,223.187Zm1.334.022a4,4,0,0,0,.947,2.8,3.063,3.063,0,0,0,2.389,1.012,3.126,3.126,0,0,0,2.411-1.033,4.2,4.2,0,0,0,.947-2.927,4.886,4.886,0,0,0-.409-2.088,3.1,3.1,0,0,0-1.184-1.378,3.23,3.23,0,0,0-1.743-.5,3.335,3.335,0,0,0-2.368.947A4.191,4.191,0,0,0,689.334,223.209Z",
  transform: "translate(-589.917 -218)",
  fill: "#ababab"
}), React.createElement("path", {
  id: "Path_939",
  "data-name": "Path 939",
  d: "M739.2,228.493V218.7h1.334l5.144,7.684V218.7h1.248v9.793h-1.334l-5.144-7.684v7.684Z",
  transform: "translate(-630.097 -218.549)",
  fill: "#ababab"
})), React.createElement("path", {
  id: "Path_769",
  d: "M59.508,162.754,52.9,156.146l1.851-1.851,4.735,4.735L69.516,149l1.851,1.873Z",
  transform: "translate(-41.514 -116.93)",
  fill: "#fff"
}));

var SvgIconSecureSsl = function SvgIconSecureSsl(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 166.829,
    height: 57.059,
    viewBox: "0 0 166.829 57.059",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconSecureSsl, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-secure-ssl.924d64b7.svg";
export { ForwardRef as ReactComponent };